import * as React from "react"
import colors from "theme/colors"

const SvgComponent = ({
  color = colors.white,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  const w = 32
  const h = 32
  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      width={w}
      height={h}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9974 28C18.9429 28 21.3307 22.6274 21.3307 16C21.3307 9.37258 18.9429 4 15.9974 4C13.0519 4 10.6641 9.37258 10.6641 16C10.6641 22.6274 13.0519 28 15.9974 28Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 16.0013C4 18.948 9.37333 21.3346 16 21.3346C22.6267 21.3346 28 18.948 28 16.0013C28 13.0546 22.6267 10.668 16 10.668C9.37333 10.668 4 13.0546 4 16.0013Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SvgComponent
